import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

/**
 * The portal's dropdown, in the shape this page needs it.
 *
 * react-select, never a bare <select>: App.css sets a global
 * `input, select, textarea { width: 100%; padding: 10px }` and the OS supplies
 * its own arrow and text metrics on top, so a native select renders unlike
 * every other control on the page and clips its own longest option.
 *
 * menuPortalTarget is not optional here — the same component is used inside the
 * lead drawer, and a menu rendered in place is clipped by the panel.
 */
const SIZE = {
    control: (base, state) => ({
        ...base,
        minHeight: 38,
        borderRadius: 8,
        borderColor: state.isFocused ? '#4c7ac5' : '#d1d5db',
        boxShadow: state.isFocused ? '0 0 0 2px rgba(76,122,197,.18)' : 'none',
        fontSize: 13.5,
        ':hover': { borderColor: state.isFocused ? '#4c7ac5' : '#9ca3af' },
    }),
    valueContainer: (base) => ({ ...base, padding: '0 10px' }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    dropdownIndicator: (base) => ({ ...base, padding: '0 8px' }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (base) => ({ ...base, fontSize: 13.5, zIndex: 100000 }),
    menuPortal: (base) => ({ ...base, zIndex: 100000 }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#4c7ac5' : state.isFocused ? '#eef4fd' : '#fff',
        color: state.isSelected ? '#fff' : '#111827',
    }),
    singleValue: (base) => ({ ...base, color: '#111827' }),
    placeholder: (base) => ({ ...base, color: '#9ca3af' }),
};

export default function LeadSelect({
    options, value, onChange, placeholder, isClearable = false, className, creatable = false,
}) {
    const opts = options || [];
    // Creatable where the list is meant to grow — the areas leads come from are
    // discovered by asking people, not decided in advance.
    const Control = creatable ? CreatableSelect : Select;
    return (
        <Control
            className={className}
            options={opts}
            value={opts.find((o) => o.value === value)
                ?? (creatable && value ? { value, label: value } : null)}
            onChange={(opt) => onChange(opt ? opt.value : '')}
            placeholder={placeholder}
            isClearable={isClearable}
            menuPortalTarget={typeof document === 'undefined' ? null : document.body}
            menuPosition="fixed"
            menuPlacement="auto"
            styles={SIZE}
            formatCreateLabel={(v) => `Add "${v}"`}
        />
    );
}
